var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conflict"},[_c('div',{staticClass:"container-fluid"},[_c('ConflictList'),_c('Pagination',{ref:"pagination",attrs:{"get":_vm.list}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }